<template>
    <div class="product-book-container__block">
        <div class="c-product-info-block">
            <a class="c-product-info-block__image" :href="item.url">
                <webp-picture :webp="item.thumbnail_webp_path">
                    <img class="c-product-info-block__cover" :src="item.thumbnail_path" alt="">
                </webp-picture>
            </a>

            <div class="c-product-info-block__detail">
                <div class="c-product-info-block__title u-text-ellipsis has-2-lines">
                    <div class="u-text-ellipsis has-2-lines">
                        <a :href="item.url">{{ item.item_title }}</a>
                    </div>
                </div>
                <div v-if="item.talents" class="c-product-info-block__name">
                    <div class="u-text-ellipsis has-2-lines">
                        <a v-for="(talent, i) in item.talents" :key="`first-${i}`"
                        :href="route(route_list, 'site.talent.detail', {model_id: talent.id, model_name: talent.name})">
                        {{ talent.name }}
                        </a>
                    </div>
                </div>
                <div class="c-product-info-block__labels">
                    <div class="c-label is-new u-mb-0" v-if="item.is_new == true">New</div>
                    <div class="c-label is-photos u-mb-0">{{ item.category }}</div>
                    <div class="c-label is-up u-mb-0" v-if="item.is_pre_order == true">予約受付中</div>
                    <div class="c-label is-limited u-mb-0" v-if="item.with_extra == true">限定特典付</div>
                </div>
                <div class="c-product-info-block__price">
                    <div class="c-product-info-block__discount">
                        <div>
                            <div class="c-product-info-block__discount-type u-mb-2">{{ getDspStartDateFormat }}</div>
                        </div>
                    </div>
                    <div v-if="item.coupon_name" class="c-product-info-block__discount">
                        <div>
                            <div class="c-product-info-block__discount-type u-mb-2">使用クーポン: {{ item.coupon_name }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import routeMixin from '../../../mixins/route.js';
    import moment from 'moment';

    export default {
        props: [
            'route_list',
            'item',
            'is_plus',
        ],
        mixins: [routeMixin],
        data() {
            return {
            }
        },
        computed: {
            moment: function (date) {
                return moment(date).format('YYYY/MM/DD');
            }
        },
        methods: {
            // 商品価格を3桁区切り
            formatPrice(price) {
                const formatter = new Intl.NumberFormat('ja-JP');
                return formatter.format(price);
            },
        },
        computed: {
            getDspStartDateFormat: function () {
            return this.item.disp_start_date ? moment(this.item.disp_start_date).format('Y年M月D日発売') : '';
        },
        }

    }
</script>

<style lang="scss" scoped>
picture {
    display: flex;
    align-items: flex-end;
    justify-content: right;
}

.c-product-info-block {
    color: var(--gj-text-color);
    width: 100%;
    display: grid;
    grid-template-columns: 148px 1fr;
    grid-template-rows: 1fr min-content;
    gap: 16px 16px;
    grid-template-areas:
        "image detail"
        "buttons buttons";

    .c-product-info-block__image {
        position: relative;
        grid-area: image;
        display: flex;
        justify-content: flex-end;

        .c-product-info-block__cover {
            width: 95%;
            aspect-ratio: 148 / 209;
            object-fit: contain;
            border: 1px solid var(--gj-border-color);
        }
    }
    .c-product-info-block__detail {
        grid-area: detail;
        display: grid;
        grid-template-rows: repeat(4, min-content);
        grid-template-areas:
            "title"
            "name"
            "labels"
            "price";
        row-gap: 4px;
    }

    .c-product-info-block__buttons {
        grid-area: buttons;
        display: flex;
        gap: 8px;

        & > * {
            flex: 1;
            font-size: 10px;
        }
    }

    .c-product-info-block__title,
    .c-product-info-block__name {
        font-weight: 600;
        display: flex;
    }

    .c-product-info-block__title {
        grid-area: title;
        font-size: 20px;
        line-height: 135%;
        min-height: 54px;
        align-items: start;
        word-break: break-all;
    }

    .c-product-info-block__name {
        grid-area: name;
        font-size: 14px;
        line-height: 130%;
        min-height: 36px;
        align-items: center;
    }
    .c-product-info-block__labels {
        grid-area: labels;
    }

    .c-product-info-block__price {
        grid-area: price;
        display: flex;
        gap: 12px;
        flex-direction: column;
    }
    .c-product-info-block__discount {
        display: flex;
        gap: 12px;
        flex-direction: column;
    }

    .c-product-info-block__discount-type {
        font-size: 11px;
        font-weight: 600;
        line-height: 130%;

        &.is-pink {
            color: var(--gj-color-pink);
        }
    }
    .c-product-info-block__discount-price {
        display: flex;
        align-items: flex-start;
    }
}

@media (min-width: 768px) {
    .c-product-info-block {
        grid-template-columns: 117px 1fr 210px;
        grid-template-rows: 1fr;
        grid-template-areas: "image detail buttons";

        .c-product-info-block__discount {
            flex-direction: row;
        }

        .c-product-info-block__buttons {
            flex-direction: column;
            justify-content: flex-end;
            & > * {
                flex: 0;
                font-size: 13px;
            }
        }
    }

    .is-tile .c-product-info-block {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(3, min-content);
        row-gap: 7px;
        grid-template-areas:
            "image"
            "detail"
            "buttons";

        .c-product-info-block__detail {
            row-gap: 8px;
            grid-template-areas:
                "labels"
                "title"
                "name"
                "price";
        }

        .c-product-info-block__title {
            font-size: 13px;
            font-style: normal;
            font-weight: 300;
            line-height: 130%;
            color: var(--gj-text-color-light);
            min-height: 34px;
        }

        .c-product-info-block__image {
            .c-product-info-block__cover {
                aspect-ratio: 238 / 337;
            }
        }

        .c-product-info-block__discount {
            flex-direction: column;
            gap: 8px;
            min-height: 92px;
        }

        .c-product-info-block__buttons {
            margin-top: 9px;
        }
    }
}
</style>
